//export const BASE_URL = "https://54jr98p7-8900.inc1.devtunnels.ms/api";
// export const BASE_URL = "http://16.171.111.244/api";
// export const BASE_URL = "http://16.170.217.59/api";
// export const BASE_URL = "http://3.27.121.219/api";
// export const BASE_URL = "https://5846vd58-8900.inc1.devtunnels.ms/api";
export const BASE_URL = "https://api.buildtrack.ca/api";
// export const IMAGE_BASE_URL = "http://3.27.121.219/";
export const IMAGE_BASE_URL = "https://api.buildtrack.ca/";
// export const IMAGE_BASE_URL = "https://40kdvfdg-8900.asse.devtunnels.ms/";
// export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "https://40kdvfdg-8900.asse.devtunnels.ms/api";

// export const BASE_URL = "http://51.21.116.59/api";
// export const BASE_URL = "https://api.testing.winwithwits.com/api";
